
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UploadingFilesObjectForTable } from '@/models/main';
import DropZone from '@/components/UI/DropZone.vue';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    DropZone,
    Icon,
  },
})
export default class ExampleDiv extends Vue {
  @Prop(String) public uploadError: string;
  @Prop(Array) public filesObjectsForTable: UploadingFilesObjectForTable[];
  @Prop(Function) public deleteFiles: (item: UploadingFilesObjectForTable) => void;
  @Prop(Function) public filesAdded: (files: File[]) => void;
}
